import React, { useState } from 'react';
import Collapse from '../../../../Components/HealthPlan/Collapse/Collapse';
// @ts-ignore
import styles from './TherapistInformationItem.module.scss';
import useTranslation from '../../../../Hooks/useTranslation';
import LinkButton from '../../../../Components/Button/LinkButton';
import { Theme } from '../../../../Enums/Theme.enum';
import UserMetaDataEdit from '../../../Meta/Components/UserMetaDataEdit/UserMetaDataEdit';
import NoEscape from '../../../../Components/NoEscape';

interface TherapistInformationSubItem {
	key: string;
	title: string;
	value: string;
}

export interface TherapistInformationItemInterface {
	language: {
		name?: string | null;
		code: string;
	};
	items: TherapistInformationSubItem[];
}

interface TherapistInformationSubItemProps {
	userId: string;
	afterSuccessfulEdit: () => void;
	item: TherapistInformationSubItem;
	languageCode: string;
}

interface Props {
	userId: string;
	afterSuccessfulEdit: () => void;
	item: TherapistInformationItemInterface;
}
const TherapistInformationItem: React.FC<Props> = ({
	userId,
	item,
	afterSuccessfulEdit,
}) => {
	return (
		<Collapse defaultOpen={true} title={item.language.name ?? ''}>
			{item.items.map((subItem, key) => (
				<React.Fragment key={key}>
					<TherapistInformationSubItem
						item={subItem}
						userId={userId}
						afterSuccessfulEdit={afterSuccessfulEdit}
						languageCode={item.language.code}
					/>
				</React.Fragment>
			))}
		</Collapse>
	);
};

const TherapistInformationSubItem: React.FC<
	TherapistInformationSubItemProps
> = ({ userId, item, afterSuccessfulEdit, languageCode }) => {
	const [isEditMode, setIsEditMode] = useState(false);
	const { t } = useTranslation();

	const handleSetEditModeOn = () => {
		setIsEditMode(true);
	};

	const handleAfterEditSuccess = () => {
		setIsEditMode(false);
		afterSuccessfulEdit();
	};

	return (
		<div className={styles.wrapper}>
			<div className={styles.titleWrapper}>
				<div className={styles.title}>{t(item.title)}</div>
				{isEditMode ? (
					<LinkButton
						title={'base.shared.cancel'}
						theme={Theme.RED}
						onClick={() => setIsEditMode(false)}
					/>
				) : (
					item.value && (
						<LinkButton
							title='base.shared.edit'
							theme={Theme.BLUE}
							onClick={handleSetEditModeOn}
							firstUpper
						/>
					)
				)}
			</div>
			{isEditMode ? (
				<UserMetaDataEdit
					userId={userId}
					metaDataItem={item}
					onSuccess={handleAfterEditSuccess}
					language={languageCode}
				/>
			) : (
				<div className={styles.content}>
					{item.value ? (
						<NoEscape>{item.value}</NoEscape>
					) : (
						<LinkButton
							title='base.writeAText'
							theme={Theme.BLUE}
							onClick={handleSetEditModeOn}
						/>
					)}
				</div>
			)}
		</div>
	);
};

export default TherapistInformationItem;
